import React, { useState, useEffect } from 'react'
import AddStoneModal from './AddStoneModal'
import CatalogItem from './CatalogItem'
import 'lightbox2/dist/css/lightbox.css'
import 'lightbox2/dist/js/lightbox-plus-jquery'
import '../assets/css/catalog.css'

const Catalog = ({ title, catalogData, isAdmin, refreshCatalog }) => {
  const [addImage, setAddImage] = useState(false)

  useEffect(() => {
    console.log('📦 Catalog received new data:', catalogData)
  }, [catalogData])

  const handleAddClick = () => setAddImage(true)

  return (
    <div className="catalogContainer">
      {/* This single header div will occupy the first two grid cells */}
      <div className="catalogHeader">{title}</div>

      <AddStoneModal
        modalIsOpen={addImage}
        setModalIsOpen={setAddImage}
        reloadData={refreshCatalog}
      />

      {catalogData
        .filter((item, i) => {
          const ok = item && typeof item.img_url === 'string'
          if (!ok) console.warn(`Skipping invalid catalogData[${i}]`, item)
          return ok
        })
        .map(item => (
          <CatalogItem
            key={item.id}
            item={item}
            isAdmin={isAdmin}
            refreshCatalog={refreshCatalog}
          />
        ))}

      {isAdmin && (
        <div className="addButtonWrapper">
          <div className="addButtonContainer" onClick={handleAddClick}>
            <button className="addButton">+</button>
          </div>
        </div>
      )}
    </div>
  )
}

export default Catalog
